import { useInfiniteQuery } from '@tanstack/react-query';
import { formatDate } from 'date-fns';
import { ILeadSearchView } from '../../aida/viewModels/leads/interfaces';
import { IPagedCollection } from '../../extViewmodels';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'lead/demosToConfirm';

export function useLeadDemosQuery({
	pageSize = 25,
	userId,
	outcomeName,
	demoPerformerUserId,
	start,
	end,
	enabled,
	managerUserId,
	companyId,
	dealStage,
	meta,
}: {
	userId?: string;
	outcomeName?: string;
	demoPerformerUserId?: string;
	start?: Date;
	end?: Date;
	pageSize?: number;
	enabled?: boolean;
	managerUserId?: string;
	companyId?: string;
	dealStage?: string[];
	meta?: LevStandardQueryMeta;
}) {
	const userSession = useUserSession();
	return useInfiniteQuery({
		queryKey: [
			BASE_QUERY_KEY,
			userId,
			outcomeName,
			demoPerformerUserId,
			start,
			end,
			managerUserId,
			companyId,
			dealStage,
		],
		queryFn: async ({ pageParam }) => {
			const searchParams = new URLSearchParams();
			const params = {
				pageSize: pageSize.toString(),
				userId,
				outcomeName,
				demoPerformerUserId,
				start: start ? formatDate(start, 'yyyy-MM-dd') : undefined,
				end: end ? formatDate(end, 'yyyy-MM-dd') : undefined,
				managerUserId,
				companyId,
				pageToken: pageParam,
			};
			for (const [key, value] of Object.entries(params)) {
				if (value != null && value !== '') {
					searchParams.append(key, value);
				}
			}
			if (dealStage) {
				dealStage.forEach(stage => {
					searchParams.append('dealStage', stage);
				});
			}
			return userSession.webServiceHelper.callAsync<IPagedCollection<ILeadSearchView>>(
				`lead/demos?${searchParams.toString()}`,
				'GET'
			);
		},
		getNextPageParam: lastPage => lastPage.pageToken,
		initialPageParam: '',
		enabled,
		meta,
	});
}
